export default "__VITE_ASSET__Cvp7k5Ee__"